import { Action, Dispatch, Middleware } from "redux";

const consoleLogMiddleware: Middleware =
  () => (next: Dispatch) => (action: Action) => {
    console.log(`redux : ${action.type}`, action);
    return next(action);
  };
export default consoleLogMiddleware;
